"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles = {
    "invosys-ui-SplitDialog-container-flex-row": {
        display: "flex",
        flexDirection: "row",
        maxHeight: "100%",
        overflow: "hidden",
        "&> div": {
            flex: "1 1 50%"
        }
    },
    "invosys-ui-SplitDialog-container-flex-column": {
        display: "flex",
        flexDirection: "column",
        maxHeight: "100%",
        overflow: "hidden",
        "&> div": {
            flex: "1 1 50%"
        }
    },
    "invosys-ui-SplitDialog-container-flex-row-reverse": {
        display: "flex",
        flexDirection: "row-reverse",
        maxHeight: "100%",
        overflow: "hidden",
        "&> div": {
            flex: "1 1 50%"
        }
    },
    "invosys-ui-SplitDialog-container-flex-column-reverse": {
        display: "flex",
        flexDirection: "column-reverse",
        maxHeight: "100%",
        overflow: "hidden",
        "&> div": {
            flex: "1 1 50%"
        }
    },
    "invosys-ui-SplitDialog-title-with-subtitle": { paddingBottom: "4px" },
    "invosys-ui-SplitDialog-subtitle": {
        "&:first-child": { paddingTop: "4px" }
    },
    "invosys-ui-SplitDialog-content-wrapper": { overflow: "auto" },
    "invosys-ui-SplitDialog-contrast-content-wrapper": { overflow: "auto" }
};
exports.default = styles;
